import 'angular:locale/data:en';
import 'angular:locale/data:sr-Latn';
import './projects/shop/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
